import { postData } from "./api";
export const contactUs = async (data) => await postData(`/api/contact`, data);
